"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ApiLicensesClient = void 0;
const ApiSubClient_1 = require("../../common/client/ApiSubClient");
const TranscriptConverter_1 = require("../../videos/model/TranscriptConverter");
const expandUrlTemplate_1 = __importDefault(require("../../common/utils/expandUrlTemplate"));
const PageableLicensesConverter_1 = require("../PageableLicensesConverter");
class ApiLicensesClient extends ApiSubClient_1.ApiSubClient {
    async getUserLicensedContent(page, size) {
        const licensedContentLink = this.getLinkOrThrow('myLicensedContent');
        return this.axios
            .get((0, expandUrlTemplate_1.default)(licensedContentLink.href, { page, size }))
            .then((response) => PageableLicensesConverter_1.PageableLicensesConverter.convert(response.data));
    }
    async getAccountLicensedContent(page, size) {
        const licensedContentLink = this.getLinkOrThrow('myAccountLicensedContent');
        return this.axios
            .get((0, expandUrlTemplate_1.default)(licensedContentLink.href, { page, size }))
            .then((response) => PageableLicensesConverter_1.PageableLicensesConverter.convert(response.data));
    }
    async createEmbedCode(licensedContent, segmentStart, segmentEnd) {
        const link = licensedContent.videoMetadata.links?.createEmbedCode;
        if (!link)
            throw new Error(`Not authorized`);
        const response = await this.axios.post(link.getOriginalLink(), {
            segmentStart: segmentStart,
            segmentEnd: segmentEnd,
        });
        return response.data;
    }
    async getDownloadVideoUrl(licensedContent) {
        const link = licensedContent.videoMetadata.links?.download;
        if (!link)
            throw new Error(`Not authorized`);
        const response = await this.axios.get(link.getOriginalLink(), {});
        return response.data._links.download.href;
    }
    getTranscript(licensedContent) {
        const transcriptLink = licensedContent.videoMetadata.links?.transcript;
        if (!transcriptLink)
            throw new Error(`Not authorized`);
        return this.axios.get(transcriptLink.getOriginalLink()).then((response) => {
            const disposition = response.headers['content-disposition'];
            const filename = TranscriptConverter_1.TranscriptConverter.GenerateFilename(disposition, licensedContent.videoMetadata.title);
            const content = response.data;
            return Promise.resolve({ content, filename });
        });
    }
    async getMetadata(content) {
        const metadataLink = content.videoMetadata.links?.downloadMetadata;
        if (!metadataLink)
            throw new Error(`Not authorized to download Metadata`);
        const response = await this.axios.get(metadataLink.getOriginalLink(), {
            headers: { accept: 'text/csv' },
        });
        const disposition = response.headers && response.headers['content-disposition'];
        const filename = (disposition && /.*filename="([^"]*)"/.exec(disposition)?.[1]) ||
            `${content.videoId}-metadata.csv`;
        return {
            content: response.data,
            filename: filename,
            mimeType: 'text/csv',
        };
    }
    async getCaptions(licensedContent) {
        const captionsLink = licensedContent.videoMetadata.links?.downloadCaptions;
        if (!captionsLink)
            throw new Error(`Captions not found`);
        const response = await this.axios.get(captionsLink.getTemplatedLink({ download: true }));
        const disposition = response.headers && response.headers['content-disposition'];
        const filename = (disposition && /.*filename="([^"]*)"/.exec(disposition)?.[1]) ||
            `${licensedContent.videoId}-captions.srt}`;
        return { content: response.data, filename };
    }
}
exports.ApiLicensesClient = ApiLicensesClient;
//# sourceMappingURL=ApiLicensesClient.js.map